module.exports = __webpack_public_path__ + "static/02-4d9d9639f1d13c14b9629ae5f4502b54.jpg";